<template>
  <dict-select
    v-model="value"
    url="/master/common/dict/baseUserSelect"
    :placeholder="placeholder"
    filterable
    clearable
    multiple
    size="small"
    @loaded="(opts) => (options = opts)"
    @change="change"
  />
</template>

<script>
export default {
  props: {
    placeholder: { type: String, default: 'Please select' },
    userCodes: { type: String, default: '' },
    userNames: { type: String, default: '' },
  },
  data() {
    return { value: [], options: [] }
  },
  computed: {
    optionsMap() {
      return Object.fromEntries(this.options.map((o) => [o.value, o]))
    },
  },
  watch: {
    userCodes() {
      this.init()
    },
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      if (!this.userCodes) return
      this.value = JSON.parse(this.userCodes)
    },
    change(val) {
      const userNames = val.map((item) => this.optionsMap[item].label)
      this.$emit('update:userCodes', JSON.stringify(val))
      this.$emit('update:userNames', JSON.stringify(userNames))
    },
  },
}
</script>

<style scoped></style>
